import React, { useEffect, useState } from 'react'
import LazyLoader from '../../page-loader/LazyLoader';
import { loadProfileDetails } from '../../../../store/Actions/ActionProfile';
import { AbstructVar } from '../abstruct-component/AbstructVar';
import { changeUserId } from '../../../../store/Actions/ActionAuth';
import { useSelectorCustom } from '../abstruct-component/useSelectorCustom';

function CheckLazyLoader({ children }) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const [loading, setLoading] = useState(true);
    const { profileDetails, loadingProfileDetails } = useSelectorCustom()
    useEffect(() => {
        if (profileDetails === null) {
            dispatch(loadProfileDetails())
        }
    }, []);
    useEffect(() => {
        if (profileDetails !== null) {
            localStorage.setItem('XX',profileDetails?.id)
        }
    }, [profileDetails])

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);
    return (
        <>
            {
                loading || loadingProfileDetails ? <LazyLoader /> : <>
                    {children}
                </>
            }
        </>
    )
}

export default CheckLazyLoader

/*import React, { useEffect, useState } from 'react'
import LazyLoader from '../../page-loader/LazyLoader';

function CheckLazyLoader({ route, children }) {
    const [loading, setLoading] = useState(true);
    const loc = window.location.pathname

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);
    return (
        <>
        {console.log(loc)}
            {
                route === loc &&
                <>
                { children }
                </>

            }
        </>
    )
}

export default CheckLazyLoader*/